import { FormControl, Input } from '@farol-ds/react'

import styles from './email-field.module.scss'

interface EmailFieldProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  disabled?: boolean
  error?: string
  label?: string
  name?: string
  autoComplete?: string
}

export function EmailField({
  value,
  onChange,
  onBlur,
  disabled,
  error,
  label = 'E-mail',
  name = 'email',
  autoComplete = 'email',
}: EmailFieldProps) {
  return (
    <FormControl error={!!error}>
      <FormControl.Label>{label}</FormControl.Label>
      <Input
        type="email"
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        autoComplete={autoComplete}
        disabled={disabled}
      />
      {error && (
        <div className={styles.errorMessage}>
          <FormControl.ErrorMessage>{error}</FormControl.ErrorMessage>
        </div>
      )}
    </FormControl>
  )
}
